import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex pb-28 my-4 w-14 relative mx-auto text-12px xxl:text-14px" }
const _hoisted_2 = {
  class: "w-64 bg-white rounded border border-gray-lp-400 text-gray-lp-600 absolute bottom-0 right-0",
  style: {"box-shadow":"0 0 2px 0.5px #e0e0e0"}
}
const _hoisted_3 = {
  class: "p-4",
  style: {"box-shadow":"0 0 2px 0.5px #e0e0e0"}
}
const _hoisted_4 = { class: "text-black-lp-300 flex flex-col w-full" }
const _hoisted_5 = {
  class: "w-6 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Attachment Orginal File ")
const _hoisted_7 = {
  class: "w-6 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Attachment Failed File ")
const _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "arrow-top absolute z-10 right-0 mr-5",
  style: {"bottom":"88px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: "pb-4 cursor-pointer flex flex-row items-center font-medium text-gray-lp-300 hover:text-red-lp-100",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toOriginalHover && _ctx.toOriginalHover(...args))),
            onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.originalHover = true)),
            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.originalHover = false))
          }, [
            (_openBlock(), _createBlock("svg", _hoisted_5, [
              _createVNode("path", {
                fill: _ctx.originalHover ? '#B82025' : '#A7A8AA',
                "fill-rule": "evenodd",
                d: "M7 4c-.265 0-.52.105-.707.293C6.105 4.48 6 4.735 6 5v14c0 .265.105.52.293.707.187.188.442.293.707.293h10c.265 0 .52-.105.707-.293.188-.187.293-.442.293-.707V9.414L12.586 4H7zM4.879 2.879C5.44 2.316 6.204 2 7 2h5.586c.53 0 1.04.21 1.414.586m0 0L19.414 8c.375.375.586.883.586 1.414V19c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879H7c-.796 0-1.559-.316-2.121-.879C4.316 20.56 4 19.796 4 19V5c0-.796.316-1.559.879-2.121M12 9c.552 0 1 .448 1 1v3.586l1.293-1.293c.39-.39 1.024-.39 1.414 0 .39.39.39 1.024 0 1.414l-3 3c-.39.39-1.024.39-1.414 0l-3-3c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0L11 13.586V10c0-.552.448-1 1-1z",
                "clip-rule": "evenodd"
              }, null, 8, ["fill"])
            ])),
            _hoisted_6
          ], 32),
          _createVNode("div", {
            class: "cursor-pointer flex flex-row items-center font-medium text-gray-lp-300 hover:text-red-lp-100",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toOriginalHover && _ctx.toOriginalHover(...args))),
            onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.failedHover = true)),
            onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.failedHover = false))
          }, [
            (_openBlock(), _createBlock("svg", _hoisted_7, [
              _createVNode("path", {
                fill: _ctx.failedHover ? '#B82025' : '#A7A8AA',
                "fill-rule": "evenodd",
                d: "M9.402 3.5c1.155-2 4.04-2 5.196 0l6.928 12c1.155 2-.288 4.5-2.598 4.5H5.072c-2.31 0-3.753-2.5-2.598-4.5l6.928-12zm1.732 1l-6.928 12c-.385.666.096 1.5.866 1.5h13.856c.77 0 1.25-.834.866-1.5l-6.928-12c-.385-.666-1.347-.666-1.732 0zM12 8c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1s-1-.448-1-1V9c0-.552.448-1 1-1zm-1 7c0-.552.448-1 1-1h.01c.552 0 1 .448 1 1s-.448 1-1 1H12c-.552 0-1-.448-1-1z",
                "clip-rule": "evenodd"
              }, null, 8, ["fill"])
            ])),
            _hoisted_8
          ], 32)
        ]),
        _hoisted_9
      ])
    ])
  ], 512)), [
    [_directive_click_outside, () => (_ctx.optionAttachment = false)]
  ])
}